import { render, staticRenderFns } from "./AvailableUserItem.vue?vue&type=template&id=2a6142b4&scoped=true"
import script from "./AvailableUserItem.vue?vue&type=script&lang=ts"
export * from "./AvailableUserItem.vue?vue&type=script&lang=ts"
import style0 from "./AvailableUserItem.vue?vue&type=style&index=0&id=2a6142b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6142b4",
  null
  
)

export default component.exports